import { type FC } from 'react'

import type { StaticImageData } from 'next/image'

import { useNotification } from '@/containers'

import { CompareAddIcon } from '../Icon/CompareAddIcon'
import ImageOptimize from '../ImageOptimize'

interface Props {
  imgSrc: StaticImageData | string | undefined
  imgAlt: string
  id: string
  price: string
  originPrice: string
  name: string
  canCompare?: boolean
  handleAddToCompare?: () => void
}

export const SearchProductItemCard: FC<Props> = ({
  imgSrc = null,
  imgAlt,
  name,
  price,
  originPrice,
  canCompare,
  handleAddToCompare
}) => {
  const { systemConfig } = useNotification()

  return (
    <div className='flex border-b border-grey-200 py-1.5'>
      <ImageOptimize
        alt={imgAlt}
        src={imgSrc || systemConfig?.imageWarehousePlaceholder || process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER || ''}
        width={60}
        priority
        height={60}
        className='h-full max-h-[60px] w-[60px] object-cover'
      />
      <div className='mx-2 flex-1 text-sm leading-tight text-dark-400'>
        <p className='line-clamp-2 font-semibold'>{name}</p>
        <p className='text-sm text-dark-500'>{originPrice}</p>
        <p className='text-lg font-semibold text-primary-base'>{price}</p>
      </div>
      {canCompare && (
        <button onClick={handleAddToCompare} className=' r-[10px] relative flex w-[110px] items-center'>
          <CompareAddIcon className='mr-[5px]'></CompareAddIcon>
          <span className='text-blue'>So sánh</span>
        </button>
      )}
    </div>
  )
}
